import de from '@translations/de/verificationCodeForm.json';
import en from '@translations/en/verificationCodeForm.json';
import pl from '@translations/pl/verificationCodeForm.json';
import sl from '@translations/sl/verificationCodeForm.json';
import uk from '@translations/uk/verificationCodeForm.json';
import bg from '@translations/bg/verificationCodeForm.json';
import cz from '@translations/cz/verificationCodeForm.json';
import fr from '@translations/fr/verificationCodeForm.json';
import gr from '@translations/gr/verificationCodeForm.json';
import it from '@translations/it/verificationCodeForm.json';
import pr from '@translations/pr/verificationCodeForm.json';
import ru from '@translations/ru/verificationCodeForm.json';
import sk from '@translations/sk/verificationCodeForm.json';
import sp from '@translations/sp/verificationCodeForm.json';
import tr from '@translations/tr/verificationCodeForm.json';
import hu from '@translations/hu/verificationCodeForm.json';
import { ITranslations } from '@/types/common';
import { VerificationCodeFormTransFields } from './types';

export const verificationCodeFormTranslations: ITranslations<VerificationCodeFormTransFields> = {
  name: 'verificationCodeForm',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
